export type MaterialId = 'recyclage' | 'ordures' | 'organiques' | 'verts'

export interface Material {
  id: MaterialId
  label: string
  hint: string
}

export interface Collection {
  id: string
  weekday: string
  date: string
  materials: MaterialId[]
}

export const materials: Record<MaterialId, Material> = {
  recyclage: { id: 'recyclage', label: 'Recycling', hint: 'Clear bags' },
  ordures: { id: 'ordures', label: 'Garbage', hint: 'Black cart' },
  organiques: { id: 'organiques', label: 'Branches and brush', hint: 'Bundled at the curb' },
  verts: { id: 'verts', label: 'Yard waste', hint: 'Paper yard bags' },
}

export const citizenAddress = '5108 - 46 Street, Bonnyville · Zone 2'

export const quickPrompts = ['Cart not collected', 'Next collection', 'Which cart goes out?', 'Something else']

export const collections: Collection[] = [
  {
    id: 'sept-10',
    weekday: 'Today',
    date: 'Thursday, September 10',
    materials: ['ordures', 'organiques', 'verts', 'recyclage'],
  },
  {
    id: 'sept-18',
    weekday: 'Friday',
    date: 'September 18',
    materials: ['recyclage', 'ordures', 'organiques'],
  },
  {
    id: 'sept-24',
    weekday: 'Thursday',
    date: 'September 24',
    materials: ['ordures', 'organiques', 'verts'],
  },
]

/** Suivi en direct du camion pour la collecte du jour. */
export const liveCollection = {
  material: 'ordures' as MaterialId,
  sector: 'Zone 2',
  truck: 'Truck 214',
  startedAt: 'Left the yard at 6:40 a.m.',
  home: [54.2686, -110.7369] as [number, number],
  /** Trajet du camion, du premier point (déjà parcouru) jusqu’à votre adresse. */
  route: [
    [54.27650, -110.75952],
    [54.27520, -110.75688],
    [54.27400, -110.75471],
    [54.27280, -110.75243],
    [54.27160, -110.75099],
    [54.27080, -110.74943],
    [54.27010, -110.74847],
    [54.26950, -110.74775],
    [54.26900, -110.74727],
    [54.26860, -110.73690],
  ] as [number, number][],
  /** Avancement initial du camion sur le trajet (0 → 1). */
  startProgress: 0.42,
}
